export const formatDate = (date: string): string => {
  if (!date) return "";

  const year = date.slice(0, 4);
  const month = date.slice(5, 7);
  const day = date.slice(8, 10);
  const hour = date.slice(11, 13);
  const min = date.slice(14, 16);

  return `${hour}:${min} | ${day}.${month}.${year}`;
};